// App.js
import './App.css';
import React, { useState, useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

// Lazy load pages & components
const HeroSection = lazy(() => import("./Component/HeroSection"));
const Resedential = lazy(() => import("./Pages/Resedential"));
const Commercial = lazy(() => import("./Pages/Commercial"));
const Corporate = lazy(() => import("./Pages/Corporate"));
const AboutUs = lazy(() => import("./Pages/Aboutus"));
const ContactUs = lazy(() => import("./Pages/ContactUs"));
const Navbar = lazy(() => import("./Component/Navbar"));
const Footer = lazy(() => import("./Pages/Footer"));
const SocialSidebar = lazy(() => import("./Component/SocialSidebar"));
const CareerForm = lazy(() => import("./Pages/CareerForm"));
const SplashScreen = lazy(() => import("./Component/SplashScreen"));
const ScrollToTop = lazy(() => import("./Component/ScrollToTop"));
const BackButton = lazy(() => import("./Component/BackButton"));

const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isHeroPage = location.pathname === "/";

  return (
    <>
      {!isHeroPage && <Navbar />}
      <ScrollToTop />
      <SocialSidebar />
      <BackButton />
      {children}
      <Footer />
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>}>
        {loading ? (
          <SplashScreen onFinish={() => setLoading(false)} />
        ) : (
          <Routes>
            <Route
              path="/"
              element={
                <LayoutWrapper>
                  <HeroSection />
                </LayoutWrapper>
              }
            />
            <Route
              path="/residential"
              element={
                <LayoutWrapper>
                  <Resedential />
                </LayoutWrapper>
              }
            />
            <Route
              path="/commercial"
              element={
                <LayoutWrapper>
                  <Commercial />
                </LayoutWrapper>
              }
            />
            <Route
              path="/corporate"
              element={
                <LayoutWrapper>
                  <Corporate />
                </LayoutWrapper>
              }
            />
            <Route
              path="/aboutUs"
              element={
                <LayoutWrapper>
                  <AboutUs />
                </LayoutWrapper>
              }
            />
            <Route
              path="/contactUs"
              element={
                <LayoutWrapper>
                  <ContactUs />
                </LayoutWrapper>
              }
            />
            <Route
              path="/careerForm"
              element={
                <LayoutWrapper>
                  <CareerForm />
                </LayoutWrapper>
              }
            />
          </Routes>
        )}
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
